import { resolvePrintDeadline } from "../config/admissionRound";

export const AllowPay = (STOPDATE) => {
  if (STOPDATE == null || String(STOPDATE).indexOf("/") === -1) {
    return false;
  }
  let [day, month, year] = String(STOPDATE).split("/");
  if (parseInt(year) > 2400) {
    year = (parseInt(year) - 543).toString();
  }
  const textDate = `${month}/${day}/${year} 23:59`;
  const enddate = new Date(textDate);
  const datenow = new Date();
  if (datenow > enddate) {
    console.log(datenow);
    console.log("มากกว่า");
    console.log(enddate);
    return true;
  } else {
    console.log(datenow);
    console.log("น้อยกว่า");
    console.log(enddate);
    return false;
  }
};

/** true = ยังไม่ถึงวันพิมพ์ (ปิดปุ่ม) | false = พิมพ์ได้ — ตาม logic เดิม */
export const PrintRegist = (ROB_ID, MAJOR_ID, DataRegister) => {
  const textDate = resolvePrintDeadline(ROB_ID, MAJOR_ID, DataRegister);
  const start = new Date(textDate);
  const datenow = new Date();
  if (datenow > start) {
    return false;
  } else {
    return true;
  }
};
